import httpService from "services/api.service";

const BASE_URL = "/purchase_order";

export const getPO = async (payload) => {
  try {
    const res = await httpService.get(BASE_URL, { params: payload });
    return res;
  } catch (error) {
    throw error.response.data.msg;
  }
};

export const createPO = async (payload) => {
  try {
    const res = await httpService.post(BASE_URL, payload);

    return res;
  } catch (error) {
    throw error.response.data.msg;
  }
};

export const updatePO = async (payload) => {
  try {
    const res = await httpService.put(BASE_URL, payload);

    return res;
  } catch (error) {
    throw error.response.data.msg;
  }
};
